import React, { SVGProps } from 'react'
import { FCC } from 'types'

export type IconSvgProps = SVGProps<SVGSVGElement> & {
 size?: number
}

export const SvgWrapper: FCC<IconSvgProps> = ({
 children,
 className,
 ...props
}) => {
 return (
  <svg
   {...props}
   height="1em"
   style={{
    display: 'inline-block',
    height: '1em',
    overflow: 'visible',
    verticalAlign: '-0.125em',
   }}
   className={className ?? ''}
  >
   {children}
  </svg>
 )
}
